import { useEffect, useState } from "react";
import { useUserContextState } from "../contexts/UserContext";
import { useIsStaff } from "./useIsStaff";

declare global {
  interface Window {
    FS: {
      identify: (
        uid: string,
        userVars?: Record<string, string | undefined | null>,
      ) => void;
      setUserVars: (
        userVars: Record<string, string | undefined | null>,
      ) => void;
    };
  }
}
export const useFullStory = (): void => {
  const { user } = useUserContextState();
  const { isStaff, loading } = useIsStaff();
  const [hasIdentified, setHasIdentified] = useState(false);

  useEffect(() => {
    if (
      !user ||
      process.env.NEXT_PUBLIC_VERCEL_ENV !== "production" ||
      hasIdentified ||
      loading
    ) {
      return;
    }

    const shouldEnableFullStory = user.email === "melanie@opus.so" || !isStaff;

    if (!shouldEnableFullStory) {
      return;
    }

    if (!window.FS) {
      console.error("FullStory not loaded");
      return;
    }

    window.FS.identify(user.id.toString());
    window.FS.setUserVars({
      displayName: user.name,
      email: user.email,
      org: user.org?.name,
      orgId: user.org?.id.toString(),
      userType: user.userType,
    });
    setHasIdentified(true);
  }, [user, hasIdentified, setHasIdentified, loading, isStaff]);
};
